import { DefaultButtonTheme, RoundedButton } from '@sparelabs/nutshell-legacy'
import React from 'react'
import { st } from 'src/locales/TranslationHelper'

interface IFormBackButtonProps {
  onClick: () => void
}
export const FormBackButton = ({ onClick }: IFormBackButtonProps): JSX.Element => (
  <RoundedButton
    theme={DefaultButtonTheme}
    onClick={() => {
      onClick()
      window.scrollTo(0, 0)
    }}
  >
    {st.common.back()}
  </RoundedButton>
)
